<template>
    <div class="rc-root">
        <div class="container">
            <!-- 头部 -->
            <header class="rc-header">
                <div class="rc-title">
                    <i class="el-icon-document"></i>
                    <h1>报告中心</h1>
<!--                    <span class="sub">筛选 · 预览 · 下载</span>-->
                </div>
                <div class="rc-metrics">
<!--                    <div class="metric" v-for="m in metrics" :key="m.key">-->
<!--                        <div class="num">{{ m.value }}</div>-->
<!--                        <div class="lbl">{{ m.label }}</div>-->
<!--                    </div>-->
                </div>
            </header>

            <!-- 筛选卡片 -->
            <el-card class="rc-card fadein" shadow="never">
                <el-form :inline="true" :model="qry" size="small" class="filter-row" @submit.native.prevent>
<!--                    <el-form-item label="主题">-->
<!--                        <el-select v-model="qry.subject" placeholder="全部主题" clearable style="width: 160px">-->
<!--                            <el-option v-for="s in subjects" :key="s" :label="s" :value="s"/>-->
<!--                        </el-select>-->
<!--                    </el-form-item>-->
                    <el-form-item label="关键词">
                        <el-input v-model="qry.keyword" placeholder="输入标题/标签/摘要" clearable style="width: 220px">
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="时间范围">
                        <el-date-picker
                                v-model="qry.dates"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                style="width: 260px"
                        />
                    </el-form-item>
<!--                    <el-form-item label="类型">-->
<!--                        <el-select v-model="qry.type" placeholder="全部" clearable style="width: 140px">-->
<!--                            <el-option label="城市日报" value="daily"/>-->
<!--                            <el-option label="区域预测" value="forecast"/>-->
<!--                            <el-option label="专题推送" value="push"/>-->
<!--                            <el-option label="其他" value="other"/>-->
<!--                        </el-select>-->
<!--                    </el-form-item>-->
                    <el-form-item>
                        <el-button size="small" type="primary" @click="onSearch" :loading="loading">查询</el-button>
                        <el-button size="small" @click="onReset" :disabled="loading">重置</el-button>
<!--                        <el-button type="primary" @click="onSearch" :loading="loading">查询</el-button>-->
<!--                        <el-button @click="onReset" :disabled="loading">重置</el-button>-->
<!--                        <el-divider direction="vertical"></el-divider>-->
                        <el-tooltip content="切换为卡片视图" placement="top" v-if="view==='table'">
                            <el-button icon="el-icon-menu" @click="view='grid'">卡片</el-button>
                        </el-tooltip>
                        <el-tooltip content="切换为表格视图" placement="top" v-else>
                            <el-button icon="el-icon-tickets" @click="view='table'">表格</el-button>
                        </el-tooltip>
                    </el-form-item>
                    <el-form-item class="right-actions">
<!--                        <el-button-->
<!--                                type="success"-->
<!--                                icon="el-icon-download"-->
<!--                                @click="batchDownload"-->
<!--                                :disabled="selRows.length===0"-->
<!--                        >-->
<!--                            批量下载({{ selRows.length }})-->
<!--                        </el-button>-->
                    </el-form-item>
                </el-form>
            </el-card>

            <!-- 表格视图 -->
            <el-card v-show="view==='table'" class="rc-card fadein" shadow="never" style="margin-top:14px">
                <div v-if="loading" style="padding:24px; color: var(--muted)">加载中…</div>
                <el-table
                        v-else
                        :data="list"
                        stripe
                        :default-sort="{prop:'time',order:'descending'}"
                >
<!--                    <el-table-column type="selection" width="50"/>-->
                    <el-table-column label="缩略图" width="120">
                        <template slot-scope="scope">
                            <div class="thumb" @click="download(scope.row)">
                                <img :src="scope.row.thumb || pdfIcon" alt="thumb"/>
                                <span class="thumb-hover">点击下载</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="报告标题" min-width="320" show-overflow-tooltip>
                        <template slot-scope="{row}">
                            <div class="title-cell">
                                <span class="title" @click="download(row)">{{ row.title }}</span>
                                <div class="tags">
                                    <el-tag v-for="t in row.tags" :key="t" size="mini" effect="plain">{{ t }}</el-tag>
                                </div>
                                <div class="desc">{{ row.summary }}</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="subject" label="主题" width="120"/>
                    <el-table-column label="时间" width="180" prop="time" sortable>
                        <template slot-scope="{row}">{{ formatTime(row.time) }}</template>
                    </el-table-column>
                    <el-table-column label="操作" width="160" fixed="right">
                        <template slot-scope="{row}">
<!--                            <el-button type="text" @click="openPreview(row)">预览</el-button>-->
<!--                            <el-divider direction="vertical"></el-divider>-->
                            <el-button type="text" @click="download(row)">下载</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pager">
                    <el-pagination
                            background
                            layout="prev, pager, next, jumper, ->, total"
                            :total="total"
                            :current-page.sync="page.page"
                            :page-size="page.size"
                            @current-change="fetchData"
                    />
                </div>
            </el-card>

            <!-- 卡片视图 -->
            <div v-show="view==='grid'" class="fadein" style="margin-top:14px">
                <div v-if="loading" style="padding:24px; color: var(--muted)">加载中…</div>
                <div class="grid-wrap" v-else>
                    <article class="r-card" v-for="row in list" :key="row.id" @click="openPreview(row)">
                        <div class="cover">
                            <img :src="row.thumb || pdfIcon" alt="thumb"/>
                            <span class="badge">{{ row.subject }}</span>
                        </div>
                        <div class="body">
                            <h3 class="r-title">{{ row.title }}</h3>
                            <p class="r-desc">{{ row.summary }}</p>
                            <div class="r-tags">
                                <el-tag v-for="t in row.tags" :key="t" size="mini" effect="plain">{{ t }}</el-tag>
                            </div>
                        </div>
                        <div class="foot">
                            <time><i class="el-icon-time"></i> {{ formatTime(row.time) }}</time>
                            <el-button type="text" @click.stop="download(row)">下载</el-button>
                        </div>
                    </article>
                </div>
                <div class="pager">
                    <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="total"
                            :current-page.sync="page.page"
                            :page-size="page.size"
                            @current-change="fetchData"
                    />
                </div>
            </div>

            <!-- 预览抽屉 -->
            <el-drawer :visible.sync="preview.visible" custom-class="preview-drawer" :with-header="false" size="70%">
                <div class="preview-head">
                    <div class="ph-left">
                        <i class="el-icon-view"></i>
                        <div>
                            <div class="ph-title">{{ preview.row && preview.row.title }}</div>
                            <div class="ph-sub">
                                <el-tag size="mini" type="info">{{ preview.row && preview.row.subject }}</el-tag>
                                <span style="color:var(--muted)"> · {{ formatTime(preview.row && preview.row.time) }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="ph-right">
                        <el-button type="primary" icon="el-icon-download" @click="download(preview.row)">下载</el-button>
                        <el-button icon="el-icon-close" @click="preview.visible=false">关闭</el-button>
                    </div>
                </div>
                <div class="preview-body">
                    <iframe
                            v-if="isPdf(preview.row && preview.row.url)"
                            class="pdf-frame"
                            :src="preview.row && preview.row.url"
                            frameborder="0"
                    />
                    <div v-else class="img-preview">
                        <el-carousel height="540px" :autoplay="false" trigger="click" indicator-position="outside">
                            <el-carousel-item v-for="(img,idx) in (preview.row && preview.row.images || [])" :key="idx">
                                <img :src="img" class="img"/>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </el-drawer>
        </div>
    </div>
</template>

<script>
    // —— 模块作用域：常量 & 工具函数 & MOCK ——
    // （避免把大数组和工具函数挂到 Vue 实例上，以免触发 vue/no-reserved-keys）
    const pdf = 'https://arxiv.org/pdf/2106.14834.pdf';
    const img1 = 'https://images.unsplash.com/photo-1545239351-1141bd82e8a6?q=80&w=1200';
    const img2 = 'https://images.unsplash.com/photo-1529101091764-c3526daf38fe?q=80&w=1200';
    const pdfIconStatic = 'https://cdn.jsdelivr.net/gh/tabler/tabler-icons/icons/brand-adobe.svg';

    function fmt(ts) {
        const d = new Date(ts);
        const p = (n) => (n < 10 ? '0' + n : n);
        return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
    }

    function mkDB() {

        //  生成随机数据
        // return Array.from({ length: 36 }).map((_, i) => {
        //     const types = ['daily', 'forecast', 'push', 'other'];
        //     const subjects = ['城市日报', '区域预测', '专题推送', '联合会商'];
        //     const t = Date.now() - i * 86400000;
        //     return {
        //         id: 'r_' + (i + 1),
        //         title:
        //             (i % 3 === 0 ? '走航报告' : i % 3 === 1 ? '走航监测' : '雷达监测日报') +
        //             '_' +
        //             new Date(t).toISOString().slice(0, 10).replace(/-/g, ''),
        //         subject: subjects[i % subjects.length],
        //         time: t,
        //         type: types[i % types.length],
        //         tags: i % 2 ? ['激光雷达', '周报'] : ['走航', '日报'],
        //         summary: i % 2
        //             ? '本期通过对XX区域走航监测，提出差异化管控建议。'
        //             : '本次监测采用固定式臭氧激光雷达水平扫描的监测方案，通过对臭氧的时空演变过程分析，用来分析本地大气污染特征及变化趋势',
        //         url: i % 2 ? pdf : '',
        //         images: i % 2 ? [] : [img1, img2],
        //         thumb: i % 2 ? img2 : img1 + '&auto=format&fit=crop&w=400&h=260&q=60',
        //     };
        // });


        let list  = [
            {
                "id": "r_1",
                "title": "走航报告_重点区域_2025年5月28日重点区域",
                "subject": "走航报告",
                "time": 1748764627000,
                "type": "forecast",
                "tags": [
                    "走航报告",
                    "重点区域"
                ],
                "summary": "盐城市重点地区走航监测报告",
                "url": "https://pro.cleanair.work/static/tmp/yancheng/2025年5月28日重点区域.docx",
                "images": [],
                "thumb": "https://pro.cleanair.work/static/tmp/yancheng/1.png"
            },
            {
                "id": "r_2",
                "title": "走航报告_重点区域_盐城重点区域走航监测4.29",
                "subject": "走航报告",
                "time": 1746085867000,
                "type": "forecast",
                "tags": [
                    "走航报告",
                    "重点区域"
                ],
                "summary": "盐城市重点地区走航监测报告",
                "url": "https://pro.cleanair.work/static/tmp/yancheng/盐城重点区域走航监测4.29.docx",
                "images": [],
                "thumb": "https://pro.cleanair.work/static/tmp/yancheng/2.png"
            },
            {
                "id": "r_3",
                "title": "走航报告_重点区域_2025.6.30开发区",
                "subject": "走航报告",
                "time": 1751356527000,
                "type": "forecast",
                "tags": [
                    "走航报告",
                    "重点区域"
                ],
                "summary": "盐城市重点地区走航监测报告",
                "url": "https://pro.cleanair.work/static/tmp/yancheng/2025.6.30开发区.docx",
                "images": [],
                "thumb": "https://pro.cleanair.work/static/tmp/yancheng/3.png"
            },
            {
                "id": "r_4",
                "title": "激光雷达报告_臭氧激光雷达监测日报_20250627",
                "subject": "臭氧激光雷达监测日报",
                "time": 1751356627000,
                "type": "forecast",
                "tags": [
                    "臭氧激光雷达监测日报",
                    "重点区域"
                ],
                "summary": "通过对臭氧的时空演变过程分析，以表征臭氧的时空变化特征，用来分析本地大气污染特征及变化趋势",
                "url": "https://pro.cleanair.work/static/tmp/yancheng/盐城市臭氧激光雷达监测日报（6月26日1时-6月26日24时）.docx",
                "images": [],
                "thumb": "https://pro.cleanair.work/static/tmp/yancheng/4.png"
            }
        ]

        return list
    }

    const MOCK_DB = mkDB();

    export default {
        name: 'ReportCenter',
        data() {
            return {
                pdfIcon: pdfIconStatic,

                // 列表数据
                loading: false,
                list: [],
                total: 0,
                page: { page: 1, size: 10 },

                // 查询参数
                qry: { subject: '', keyword: '', dates: [], type: '' },
                view: 'table',
                selRows: [],

                // 快捷标签（预留）
                quickTags: ['日报', '区域', '预测', '臭氧', '颗粒物', '管控建议'],
                activeQuickTags: [],

                // 选项 / 指标
                subjects: Array.from(new Set(MOCK_DB.map((r) => r.subject))),
                metrics: [
                    { key: 'all', label: '报告总数', value: MOCK_DB.length },
                    {
                        key: 'month',
                        label: '本月新增',
                        value: MOCK_DB.filter((r) => {
                            const d = new Date();
                            d.setDate(1);
                            d.setHours(0, 0, 0, 0);
                            return r.time >= d.getTime();
                        }).length,
                    },
                    { key: 'downloads', label: '累计下载', value: Math.round(MOCK_DB.length * 13.6) },
                ],

                // 预览
                preview: { visible: false, row: null },
            };
        },
        created() {
            this.fetchData(1);
        },
        methods: {
            formatTime(ts) {
                return fmt(ts);
            },
            async fetchData(page) {
                this.loading = true;
                this.page.page = page || this.page.page;

                const { subject, keyword, dates, type } = this.qry;
                const tags = this.activeQuickTags;


                console.log(MOCK_DB)

                let rows = MOCK_DB.slice().filter((r) => {
                    const okSubject = !subject || r.subject === subject;
                    const okType = !type || r.type === type;
                    const okKey =
                        !keyword ||
                        r.title.includes(keyword) ||
                        r.summary.includes(keyword) ||
                        r.tags.some((t) => t.includes(keyword));
                    const okTags = !tags.length || tags.every((t) => r.tags.includes(t));
                    const okDates =
                        !dates || dates.length < 2
                            ? true
                            : new Date(r.time) >= new Date(dates[0]) &&
                            new Date(r.time) <= new Date(dates[1] + ' 23:59:59');

                    return okSubject && okType && okKey && okTags && okDates;
                });

                rows.sort((a, b) => b.time - a.time);
                const total = rows.length;
                const start = (this.page.page - 1) * this.page.size;
                const records = rows.slice(start, start + this.page.size);

                // 模拟接口延迟
                setTimeout(() => {
                    this.list = records;
                    this.total = total;
                    this.loading = false;
                }, 300);
            },
            onSearch() {
                this.fetchData(1);
            },
            onReset() {
                this.qry = { subject: '', keyword: '', dates: [], type: '' };
                this.activeQuickTags = [];
                this.fetchData(1);
            },
            toggleQuick(tag) {
                const s = new Set(this.activeQuickTags);
                s.has(tag) ? s.delete(tag) : s.add(tag);
                this.activeQuickTags = [...s];
                this.fetchData(1);
            },
            openPreview(row) {
                this.preview.row = row;
                this.preview.visible = true;
            },
            isPdf(url) {
                return typeof url === 'string' && /\.pdf(\?|$)/i.test(url);
            },
            download(row) {
                if (!row) return;
                const url = row.url || (row.images && row.images[0]) || row.thumb;
                if (url) window.open(url, '_blank');
            },
            batchDownload() {
                this.selRows.forEach((r) => this.download(r));
                this.$message.success(`已开始批量下载 ${this.selRows.length} 个文件`);
            },
        },
    };
</script>

<style>
    /* 变量挂在组件根节点，便于样式继承与隔离 */
    .rc-root {
        --card-bg: #ffffff;
        --soft: #f7f9fc;
        --muted: #909399;
        --border: #e6ebf5;
        --accent: #3f8cff;
        --shadow: 0 8px 24px rgba(31, 35, 41, 0.06);
        background: #f3f6fb;
        color: #2b2f33;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
    }

    .container {
        max-width: 1200px;
        margin: 20px auto;
        padding: 0 16px;
    }

    .rc-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 14px;
        padding: 20px;
    }

    .rc-title {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .rc-title i {
        font-size: 22px;
        color: var(--accent);
    }

    .rc-title h1 {
        font-size: 18px;
        margin: 0;
    }

    .rc-title .sub {
        margin-left: 10px;
        color: var(--muted);
        font-size: 12px;
    }

    .rc-metrics {
        display: grid;
        grid-auto-flow: column;
        gap: 18px;
    }

    .metric {
        min-width: 110px;
        background: var(--card-bg);
        border: 1px solid var(--border);
        border-radius: 14px;
        padding: 10px 14px;
        box-shadow: var(--shadow);
    }

    .metric .num {
        font-weight: 700;
        font-size: 18px;
    }

    .metric .lbl {
        color: var(--muted);
        font-size: 12px;
    }

    .rc-card {
        border-radius: 14px;
        background: var(--card-bg);
        border: 1px solid var(--border);
        box-shadow: var(--shadow);
    }

    .filter-row {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    .right-actions {
        margin-left: auto;
    }

    .quick-tags {
        padding: 8px 6px 4px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;
    }

    .quick-tags .tip {
        color: var(--muted);
        font-size: 12px;
        margin-right: 6px;
    }

    .quick-tag {
        cursor: pointer;
        user-select: none;
        transition: transform .08s ease;
    }

    .quick-tag:active {
        transform: scale(0.98);
    }

    .thumb {
        width: 90px;
        height: 66px;
        border-radius: 8px;
        overflow: hidden;
        position: relative;
        cursor: pointer;
        border: 1px solid var(--border);
        background: var(--soft);
    }

    .thumb img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }

    .thumb .thumb-hover {
        position: absolute;
        inset: 0;
        display: grid;
        place-items: center;
        color: #fff;
        font-size: 12px;
        background: rgba(0, 0, 0, 0.35);
        opacity: 0;
        transition: .24s;
    }

    .thumb:hover .thumb-hover {
        opacity: 1;
    }

    .title-cell .title {
        font-weight: 600;
        cursor: pointer;
    }

    .title-cell .title:hover {
        color: var(--accent);
    }

    .title-cell .tags {
        margin-top: 4px;
        display: flex;
        gap: 6px;
        flex-wrap: wrap;
    }

    .title-cell .desc {
        margin-top: 4px;
        font-size: 12px;
        color: var(--muted);
    }

    .pager {
        padding: 12px 6px 0;
        display: flex;
        justify-content: flex-end;
    }

    .grid-wrap {
        display: grid;
        gap: 16px;
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }

    @media (max-width: 1400px) {
        .grid-wrap {
            grid-template-columns: repeat(3, 1fr);
        }
    }

    @media (max-width: 1100px) {
        .grid-wrap {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    .r-card {
        border: 1px solid var(--border);
        border-radius: 16px;
        background: var(--card-bg);
        box-shadow: var(--shadow);
        overflow: hidden;
        transform: translateY(0);
        transition: transform .18s ease, box-shadow .18s ease;
        cursor: pointer;
    }

    .r-card:hover {
        transform: translateY(-4px);
        box-shadow: 0 12px 28px rgba(31, 35, 41, 0.10);
    }

    .r-card .cover {
        position: relative;
        height: 132px;
        background: var(--soft);
    }

    .r-card .cover img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }

    .r-card .cover .badge {
        position: absolute;
        left: 12px;
        top: 12px;
        background: rgba(255, 255, 255, .8);
        backdrop-filter: blur(6px);
        border: 1px solid var(--border);
        border-radius: 999px;
        padding: 4px 10px;
        font-size: 12px;
        color: #000000;
    }

    .r-card .body {
        padding: 12px 14px 0;
    }

    .r-card .r-title {
        font-size: 14px;
        margin: 0 0 6px;
        line-height: 1.5;
    }

    .r-card .r-desc {
        color: var(--muted);
        font-size: 12px;
        height: 34px;
        overflow: hidden;
    }

    .r-card .r-tags {
        margin: 8px 0 0;
        display: flex;
        gap: 6px;
        flex-wrap: wrap;
    }

    .r-card .foot {
        padding: 10px 14px 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: var(--muted);
        border-top: 1px dashed var(--border);
    }

    .preview-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 14px 16px;
        background: #fff;
        border-bottom: 1px solid var(--border);
    }

    .ph-left {
        display: flex;
        gap: 10px;
        align-items: center;
    }

    .ph-title {
        font-weight: 700;
    }

    .preview-body {
        padding: 12px;
        height: calc(100% - 64px);
        overflow: auto;
        background: #f7f9fc;
    }

    .pdf-frame {
        width: 100%;
        height: calc(100vh - 200px);
        border-radius: 10px;
        background: #fff;
    }

    .img-preview .img {
        width: 100%;
        height: 540px;
        object-fit: contain;
        background: #fff;
    }

    .fadein {
        animation: fadein .28s ease both;
    }

    @keyframes fadein {
        from {
            opacity: 0;
            transform: translateY(6px);
        }
        to {
            opacity: 1;
            transform: none;
        }
    }

    /* —— 统一 el-card__body 内筛选行控件高度与对齐 —— */
    .rc-root .el-card__body .el-form--inline .el-form-item {
        /* 用 inline-flex 让 label/控件在同一基线垂直居中 */
        display: inline-flex;
        align-items: center;
        margin-bottom: 8px;
    }

    /* Label 与内容的行高一致 */
    .rc-root .el-card__body .el-form-item__label {
        line-height: 32px;
        padding-right: 10px;
    }

    /* 内容容器行高对齐 */
    .rc-root .el-card__body .el-form-item__content {
        line-height: 32px;
    }

    /* 通用输入框/选择器高度（small=32px） */
    .rc-root .el-card__body .el-input--small .el-input__inner,
    .rc-root .el-card__body .el-select .el-input__inner {
        height: 32px;
        line-height: 32px;
        box-sizing: border-box;
    }

    /* 输入框前缀/后缀图标垂直居中 */
    .rc-root .el-card__body .el-input__icon {
        line-height: 32px;
    }

    /* 按钮统一高度与内边距 */
    .rc-root .el-card__body .el-button--small {
        height: 32px;
        line-height: 32px;
        padding: 0 12px;
    }

    /* —— 日期范围选择器（daterange）特调 —— */
    /* 外壳高度 */
    .rc-root .el-card__body .el-date-editor.el-input--small,
    .rc-root .el-card__body .el-range-editor--small.el-input__inner {
        height: 32px;
        line-height: 32px;
        box-sizing: border-box;
        padding: 0 10px;            /* 去掉多余内边距，避免“看起来更高” */
    }


    /* 中间分隔符垂直居中 */
    .rc-root .el-card__body .el-range-editor--small .el-range-separator {
        line-height: 32px;
        min-width: 30px;
    }

    /* 日期图标垂直居中 */
    .rc-root .el-card__body .el-date-editor .el-input__prefix,
    .rc-root .el-card__body .el-date-editor .el-input__suffix {
        height: 32px;
        line-height: 32px;
    }

    /* Tooltip 包裹的按钮可能因为 inline 元素导致基线偏移，强制顶部对齐即可 */
    .rc-root .el-card__body .el-form-item .el-tooltip .el-button--small {
        vertical-align: top;
    }

</style>
